import * as React from 'react';
import { PropsWithChildren, useMemo, ReactElement } from 'react';
import { initialState, reducer } from 'state/reducers/dictionary';
import { DictionaryContext } from 'models/dictionaryContext';
import { DictionaryActionTypes } from 'state/actions/dictionary';
import {
  getDictionary,
  getTransactionInitialTypesDictionary,
  getTransactionMiddleTypesDictionary,
} from 'requests/dictionary';
import { EDictionaryTypes, ETransactionDictionaryItemTypes } from 'models/dictionary';

type DictionaryProviderProps = PropsWithChildren<{ children: React.ReactNode }>;
export const DictionaryProvider = ({ children }: DictionaryProviderProps): ReactElement => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const getGender = async () => {
    dispatch({ type: DictionaryActionTypes.SET_GENDER, payload: [] });
    const genderData = await getDictionary(EDictionaryTypes.Gender);
    dispatch({ type: DictionaryActionTypes.SET_GENDER, payload: genderData });
  };
  const getOrganisationStateType = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ORGANIZATION_STATE_TYPE,
      payload: [],
    });
    const organizationStateTypes = await getDictionary(EDictionaryTypes.OrganisationStateType);
    dispatch({
      type: DictionaryActionTypes.SET_ORGANIZATION_STATE_TYPE,
      payload: organizationStateTypes,
    });
  };
  const getOrganisationCivilianType = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ORGANIZATION_CIVILIAN_TYPE,
      payload: [],
    });
    const organizationCivilianTypes = await getDictionary(
      EDictionaryTypes.OrganisationCivilianType,
    );
    dispatch({
      type: DictionaryActionTypes.SET_ORGANIZATION_CIVILIAN_TYPE,
      payload: organizationCivilianTypes,
    });
  };

  const getOrganisationMilitaryType = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ORGANIZATION_MILITARY_TYPE,
      payload: [],
    });
    const organizationMilitaryTypes = await getDictionary(
      EDictionaryTypes.OrganisationMilitaryType,
    );
    dispatch({
      type: DictionaryActionTypes.SET_ORGANIZATION_MILITARY_TYPE,
      payload: organizationMilitaryTypes,
    });
  };

  const getOrganisationPoliceType = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ORGANIZATION_POLICE_TYPE,
      payload: [],
    });
    const organizationPoliceTypes = await getDictionary(
      EDictionaryTypes.OrganisationPoliceType,
    );
    dispatch({
      type: DictionaryActionTypes.SET_ORGANIZATION_POLICE_TYPE,
      payload: organizationPoliceTypes,
    });
  };

  const getOrganisationCategory = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ORGANISATION_CATEGORY,
      payload: [],
    });
    const organisationCategory = await getDictionary(EDictionaryTypes.OrganisationCategory);
    dispatch({
      type: DictionaryActionTypes.SET_ORGANISATION_CATEGORY,
      payload: organisationCategory,
    });
  };

  const getLegalVisibility = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_VISIBILITY,
      payload: [],
    });
    const legalVisibilityData = await getDictionary(EDictionaryTypes.LegalVisibility);
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_VISIBILITY,
      payload: legalVisibilityData,
    });
  };

  const getLegalEntityPrefix = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_ENTITY_PREFIX,
      payload: [],
    });
    const legalEntityPrefixData = await getDictionary(EDictionaryTypes.legalEntityPrefix);
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_ENTITY_PREFIX,
      payload: legalEntityPrefixData,
    });
  };

  const getCivilianPrefix = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_CIVILIAN_PREFIX,
      payload: [],
    });
    const prefixData = await getDictionary(EDictionaryTypes.civilianPrefix);
    dispatch({
      type: DictionaryActionTypes.SET_CIVILIAN_PREFIX,
      payload: prefixData,
    });
  };

  const getMilitaryPrefix = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_MILITARY_PREFIX,
      payload: [],
    });
    const prefixData = await getDictionary(EDictionaryTypes.militaryPrefix);
    dispatch({
      type: DictionaryActionTypes.SET_MILITARY_PREFIX,
      payload: prefixData,
    });
  };

  const getPolicePrefix = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_POLICE_PREFIX,
      payload: [],
    });
    const prefixData = await getDictionary(EDictionaryTypes.policePrefix);
    dispatch({
      type: DictionaryActionTypes.SET_POLICE_PREFIX,
      payload: prefixData,
    });
  };

  const getMake = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_MAKE,
      payload: [],
    });
    const makeData = await getDictionary(EDictionaryTypes.Make);
    dispatch({
      type: DictionaryActionTypes.SET_MAKE,
      payload: makeData,
    });
  };

  const getModel = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_MODEL,
      payload: [],
    });
    const modelData = await getDictionary(EDictionaryTypes.Model);
    dispatch({
      type: DictionaryActionTypes.SET_MODEL,
      payload: modelData,
    });
  };

  const getCaliber = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_CALIBER,
      payload: [],
    });
    const caliberData = await getDictionary(EDictionaryTypes.Caliber);
    dispatch({
      type: DictionaryActionTypes.SET_CALIBER,
      payload: caliberData,
    });
  };

  const getBarrelType = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_BARREL_TYPE,
      payload: [],
    });
    const barrelTypeData = await getDictionary(EDictionaryTypes.BarrelType);
    dispatch({
      type: DictionaryActionTypes.SET_BARREL_TYPE,
      payload: barrelTypeData,
    });
  };

  const getState = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_STATE,
      payload: [],
    });
    const stateData = await getDictionary(EDictionaryTypes.State);
    dispatch({
      type: DictionaryActionTypes.SET_STATE,
      payload: stateData,
    });
  };

  const getRegion = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_REGION,
      payload: [],
    });
    const regionData = await getDictionary(EDictionaryTypes.Region);
    dispatch({
      type: DictionaryActionTypes.SET_REGION,
      payload: regionData,
    });
  };

  const getCountry = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_COUNTRY,
      payload: [],
    });
    const countryData = await getDictionary(EDictionaryTypes.Country);
    dispatch({
      type: DictionaryActionTypes.SET_COUNTRY,
      payload: countryData,
    });
  };
  const getCountryAll = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_COUNTRY_ALL,
      payload: [],
    });
    const countryData = await getDictionary(EDictionaryTypes.CountryAll);
    dispatch({
      type: DictionaryActionTypes.SET_COUNTRY_ALL,
      payload: countryData,
    });
  };

  const getPhoneCode = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_PHONE_CODE,
      payload: [],
    });
    const phoneCodeData = await getDictionary(EDictionaryTypes.PhoneCode);
    dispatch({
      type: DictionaryActionTypes.SET_PHONE_CODE,
      payload: phoneCodeData,
    });
  };

  const getAddressType = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ADDRESS_TYPE,
      payload: [],
    });
    const addressTypeData = await getDictionary(EDictionaryTypes.AddressType);
    dispatch({
      type: DictionaryActionTypes.SET_ADDRESS_TYPE,
      payload: addressTypeData,
    });
  };

  const getLegality = async () => {
    dispatch({ type: DictionaryActionTypes.SET_LEGALITY, payload: [] });
    const legalityData = await getDictionary(EDictionaryTypes.Legality);
    dispatch({ type: DictionaryActionTypes.SET_LEGALITY, payload: legalityData });
  };

  const getManufacturer = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_MANUFACTURER,
      payload: [],
    });
    const manufacturerData = await getDictionary(EDictionaryTypes.Manufacturer);
    dispatch({
      type: DictionaryActionTypes.SET_MANUFACTURER,
      payload: manufacturerData,
    });
  };

  const getLevel = async () => {
    dispatch({ type: DictionaryActionTypes.SET_LEVEL, payload: [] });
    const levelData = await getDictionary(EDictionaryTypes.Level);
    dispatch({ type: DictionaryActionTypes.SET_LEVEL, payload: levelData });
  };

  const getFirearmAction = async () => {
    dispatch({ type: DictionaryActionTypes.SET_FIREARM_ACTION, payload: [] });
    const firearmActionData = await getDictionary(EDictionaryTypes.FirearmAction);
    dispatch({ type: DictionaryActionTypes.SET_FIREARM_ACTION, payload: firearmActionData });
  };

  const getFirearmType = async () => {
    dispatch({ type: DictionaryActionTypes.SET_FIREARM_TYPE, payload: [] });
    const firearmTypeData = await getDictionary(EDictionaryTypes.FirearmType);
    dispatch({ type: DictionaryActionTypes.SET_FIREARM_TYPE, payload: firearmTypeData });
  };

  const getTransactionType = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_TRANSACTION_TYPE,
      payload: [],
    });
    const transactionTypeData = await getDictionary(EDictionaryTypes.TransactionType);
    dispatch({
      type: DictionaryActionTypes.SET_TRANSACTION_TYPE,
      payload: transactionTypeData,
    });
  };

  const getActivity = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ACTIVITY, payload: [] });
    const activityData = await getDictionary(EDictionaryTypes.Activity);
    dispatch({
      type: DictionaryActionTypes.SET_ACTIVITY,
      payload: activityData,
    });
  };

  const getLegalClassification = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_CLASSIFICATION,
      payload: [],
    });
    const legalClassificationData = await getDictionary(EDictionaryTypes.LegalClassification);
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_CLASSIFICATION,
      payload: legalClassificationData,
    });
  };

  const getManufacturerCountry = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_COUNTRY_OF_MANUFACTURER,
      payload: [],
    });
    const manufacturerCountryData = await getDictionary(EDictionaryTypes.ManufacturerCountry);
    dispatch({
      type: DictionaryActionTypes.SET_COUNTRY_OF_MANUFACTURER,
      payload: manufacturerCountryData,
    });
  };

  const getTransactionInitialTypes = async (itemType: ETransactionDictionaryItemTypes) => {
    dispatch({
      type: DictionaryActionTypes.SET_TRANSACTION_INITIAL_TYPES,
      payload: [],
    });
    const transactionInitialTypeData = await getTransactionInitialTypesDictionary(itemType);
    dispatch({
      type: DictionaryActionTypes.SET_TRANSACTION_INITIAL_TYPES,
      payload: transactionInitialTypeData,
    });
  };

  const getTransactionMiddleTypes = async (itemType: ETransactionDictionaryItemTypes) => {
    dispatch({
      type: DictionaryActionTypes.SET_TRANSACTION_MIDDLE_TYPES,
      payload: [],
    });
    const transactionMiddleTypeData = await getTransactionMiddleTypesDictionary(itemType);
    dispatch({
      type: DictionaryActionTypes.SET_TRANSACTION_MIDDLE_TYPES,
      payload: transactionMiddleTypeData,
    });
  };

  const getArtAncillaryOptions = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_ANCILLARY_OPTIONS, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAncillaryOptions);
    dispatch({ type: DictionaryActionTypes.SET_ART_ANCILLARY_OPTIONS, payload: data });
  };
  const getArtAccessoryCalibre = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_CALIBRE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryCalibre);
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_CALIBRE, payload: data });
  };
  const getArtAccessoryComposition = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_COMPOSITION, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtaccessoryComposition);
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_COMPOSITION, payload: data });
  };
  const getArtAccessoryHostType = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_HOST_TYPE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryHostType);
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_HOST_TYPE, payload: data });
  };
  const getArtAccessoryLightColour = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_LIGHT_COLOUR, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryLightColour);
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_LIGHT_COLOUR, payload: data });
  };
  const getArtAccessoryMagnification = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_MAGNIFICATION, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryMagnification);
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_MAGNIFICATION, payload: data });
  };
  const getArtAccessoryManufacturerFlashEliminator = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ART_ACCESSORY_MANUFACTURER_FLASH_ELIMINATOR,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryManufacturerFlashEliminator);
    dispatch({
      type: DictionaryActionTypes.SET_ART_ACCESSORY_MANUFACTURER_FLASH_ELIMINATOR,
      payload: data,
    });
  };
  const getArtAccessoryManufacturerLaserLightModule = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ART_ACCESSORY_MANUFACTURER_LASER_LIGHT_MODULE,
      payload: [],
    });
    const data = await getDictionary(
      EDictionaryTypes.ArtAccessoryManufacturerLaserLightModule,
    );
    dispatch({
      type: DictionaryActionTypes.SET_ART_ACCESSORY_MANUFACTURER_LASER_LIGHT_MODULE,
      payload: data,
    });
  };
  const getArtAccessoryManufacturerMagazine = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ART_ACCESSORY_MANUFACTURER_MAGAZINE,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryManufacturerMagazine);
    dispatch({
      type: DictionaryActionTypes.SET_ART_ACCESSORY_MANUFACTURER_MAGAZINE,
      payload: data,
    });
  };
  const getArtAccessoryManufacturerOpticalSight = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ART_ACCESSORY_MANUFACTURER_OPTICAL_SIGHT,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryManufacturerOpticalSight);
    dispatch({
      type: DictionaryActionTypes.SET_ART_ACCESSORY_MANUFACTURER_OPTICAL_SIGHT,
      payload: data,
    });
  };
  const getArtAccessoryManufacturerSuppressor = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ART_ACCESSORY_MANUFACTURER_SUPPRESSOR,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryManufacturerSuppressor);
    dispatch({
      type: DictionaryActionTypes.SET_ART_ACCESSORY_MANUFACTURER_SUPPRESSOR,
      payload: data,
    });
  };
  const getArtAccessoryReticle = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_RETICLE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryReticle);
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_RETICLE, payload: data });
  };
  const getArtAccessoryType = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_TYPE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryType);
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_TYPE, payload: data });
  };
  const getArtAccessoryUtility = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_UTILITY, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryUtility);
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_UTILITY, payload: data });
  };
  const getArtAccessoryProofHouse = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_PROOF_HOUSE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAccessoryProofHouse);
    dispatch({ type: DictionaryActionTypes.SET_ART_ACCESSORY_PROOF_HOUSE, payload: data });
  };
  const getArtAmmunitionType = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_TYPE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionType);
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_TYPE, payload: data });
  };
  const getArtAmmunitionManufacturer = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_MANUFACTURER, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionManufacturer);
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_MANUFACTURER, payload: data });
  };
  const getArtAmmunitionFactory = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_FACTORY, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionFactory);
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_FACTORY, payload: data });
  };
  const getArtAmmunitionCalibreGauge = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_CALIBRE_GAUGE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionCalibreGauge);
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_CALIBRE_GAUGE, payload: data });
  };
  const getArtAmmunitionCartridgeComposition = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ART_AMMUNITION_CARTRIDGE_COMPOSITION,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionCartridgeComposition);
    dispatch({
      type: DictionaryActionTypes.SET_ART_AMMUNITION_CARTRIDGE_COMPOSITION,
      payload: data,
    });
  };
  const getArtAmmunitionColourOfPrimerSealant = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ART_AMMUNITION_COLOUR_OF_PRIMER_SEALANT,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionColourOfPrimerSealant);
    dispatch({
      type: DictionaryActionTypes.SET_ART_AMMUNITION_COLOUR_OF_PRIMER_SEALANT,
      payload: data,
    });
  };
  const getArtAmmunitionProjectileShape = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_PROJECTILE_SHAPE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionProjectileShape);
    dispatch({
      type: DictionaryActionTypes.SET_ART_AMMUNITION_PROJECTILE_SHAPE,
      payload: data,
    });
  };
  const getArtAmmunitionFunctionalType = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_FUNCTIONAL_TYPE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionFunctionalType);
    dispatch({
      type: DictionaryActionTypes.SET_ART_AMMUNITION_FUNCTIONAL_TYPE,
      payload: data,
    });
  };
  const getArtAmmunitionShotSize = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_SHOT_SIZE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionShotSize);
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_SHOT_SIZE, payload: data });
  };
  const getArtAmmunitionMunitionType = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_MUNITION_TYPE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionMunitionType);
    dispatch({ type: DictionaryActionTypes.SET_ART_AMMUNITION_MUNITION_TYPE, payload: data });
  };
  const getArtAmmunitionMunitionVelocity = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ART_AMMUNITION_MUNITION_VELOCITY,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.ArtAmmunitionMunitionVelocity);
    dispatch({
      type: DictionaryActionTypes.SET_ART_AMMUNITION_MUNITION_VELOCITY,
      payload: data,
    });
  };

  const getArtComponentType = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPONENT_TYPE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtComponentType);
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPONENT_TYPE, payload: data });
  };
  const getArtComponentManufacturer = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPONENT_MANUFACTURER, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtComponentManufacturer);
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPONENT_MANUFACTURER, payload: data });
  };
  const getArtComponentCalibre = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPONENT_CALIBRE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtComponentCalibre);
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPONENT_CALIBRE, payload: data });
  };
  const getArtComponentCapacity = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPONENT_CAPACITY, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtComponentCapacity);
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPONENT_CAPACITY, payload: data });
  };
  const getArtComponentProofHouse = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPONENT_PROOF_HOUSE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtComponentProofHouse);
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPONENT_PROOF_HOUSE, payload: data });
  };
  const getArtComposition = async () => {
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPOSITION, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ArtComposition);
    dispatch({ type: DictionaryActionTypes.SET_ART_COMPOSITION, payload: data });
  };
  const getAuditLogModule = async () => {
    dispatch({ type: DictionaryActionTypes.SET_AUDIT_LOG_MODULE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.AuditLogModule);
    dispatch({ type: DictionaryActionTypes.SET_AUDIT_LOG_MODULE, payload: data });
  };

  const getAuditLogEventType = async () => {
    dispatch({ type: DictionaryActionTypes.SET_AUDIT_LOG_EVENT_TYPE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.AuditLogEventType);
    dispatch({ type: DictionaryActionTypes.SET_AUDIT_LOG_EVENT_TYPE, payload: data });
  };

  const getAuditLogEventName = async () => {
    dispatch({ type: DictionaryActionTypes.SET_AUDIT_LOG_EVENT_NAME, payload: [] });
    const data = await getDictionary(EDictionaryTypes.AuditLogEventName);
    dispatch({ type: DictionaryActionTypes.SET_AUDIT_LOG_EVENT_NAME, payload: data });
  };

  const getApiKeyType = async () => {
    dispatch({ type: DictionaryActionTypes.SET_API_KEY_TYPE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.ApiKeyType);
    dispatch({ type: DictionaryActionTypes.SET_API_KEY_TYPE, payload: data });
  };

  const getWeaponLicenceRegion = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_REGION, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceRegion);
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_REGION, payload: data });
  };

  const getOtherRequestTaskName = async () => {
    dispatch({ type: DictionaryActionTypes.SET_OTHER_REQUEST_TASK_NAME, payload: [] });
    const data = await getDictionary(EDictionaryTypes.otherRequestTaskName);
    dispatch({ type: DictionaryActionTypes.SET_OTHER_REQUEST_TASK_NAME, payload: data });
  };

  const getTask = async () => {
    dispatch({ type: DictionaryActionTypes.SET_TASK, payload: [] });
    const data = await getDictionary(EDictionaryTypes.task);
    dispatch({ type: DictionaryActionTypes.SET_TASK, payload: data });
  };
  const getWeaponLicenceCategory = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_CATEGORY, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceCategory);
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_CATEGORY, payload: data });
  };
  const getWeaponLicencePrimaryPurpose = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_PRIMARY_PURPOSE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicencePrimaryPurpose);
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCE_PRIMARY_PURPOSE,
      payload: data,
    });
  };
  const getWeaponLicenceCondition = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_CONDITION, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceCondition);
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_CONDITION, payload: data });
  };
  const getWeaponLicenceCompetency = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_COMPETENCY, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceCompetency);
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_COMPETENCY, payload: data });
  };
  const getWeaponLicenceLimit = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_LIMIT, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceLimit);
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_LIMIT, payload: data });
  };
  const getWeaponLicenceDuration = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_DURATION, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceDuration);
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_DURATION, payload: data });
  };
  const getWeaponLicenceFee = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_FEE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceFee);
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCE_FEE, payload: data });
  };
  const getWeaponLicencingAuthority = async () => {
    const data = await getDictionary(EDictionaryTypes.weaponLicencingAuthority);
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCING_AUTHORITY, payload: data });
  };
  const getWeaponLicenceGoodReason = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCING_GOOD_REASON, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceGoodReason);
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCING_GOOD_REASON, payload: data });
  };
  const getWeaponLicencePaymentStatus = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCING_PAYMENT_STATUS, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicencePaymentStatus);
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCING_PAYMENT_STATUS,
      payload: data,
    });
  };
  const getWeaponLicenceStatus = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCING_STATUS, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceStatus);
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCING_STATUS,
      payload: data,
    });
  };
  const getWeaponLicenceHistoryAction = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCING_HISTORY_ACTION, payload: [] });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceHistoryAction);
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCING_HISTORY_ACTION,
      payload: data,
    });
  };
  const getApplicationProcessTypes = async () => {
    dispatch({ type: DictionaryActionTypes.SET_WEAPON_LICENCING_PROCESS_TYPESS, payload: [] });
    const data = await getDictionary(EDictionaryTypes.applicationProcessTypes);
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCING_PROCESS_TYPESS,
      payload: data,
    });
  };
  const getCaseProcessTypes = async () => {
    dispatch({ type: DictionaryActionTypes.SET_CASE_PROCESS_TYPES, payload: [] });
    const data = await getDictionary(EDictionaryTypes.caseProcessTypes);
    dispatch({
      type: DictionaryActionTypes.SET_CASE_PROCESS_TYPES,
      payload: data,
    });
  };
  const getCaseRejectionReason = async () => {
    dispatch({ type: DictionaryActionTypes.SET_CASE_REJECTION_REASON, payload: [] });
    const data = await getDictionary(EDictionaryTypes.caseRejectionReason);
    dispatch({ type: DictionaryActionTypes.SET_CASE_REJECTION_REASON, payload: data });
  };
  const getCaseApprovalReason = async () => {
    dispatch({ type: DictionaryActionTypes.SET_CASE_APPROVAL_REASON, payload: [] });
    const data = await getDictionary(EDictionaryTypes.caseApprovalReason);
    dispatch({ type: DictionaryActionTypes.SET_CASE_APPROVAL_REASON, payload: data });
  };
  const getCaseRefusalReason = async () => {
    dispatch({ type: DictionaryActionTypes.SET_CASE_REFUSAL_REASON, payload: [] });
    const data = await getDictionary(EDictionaryTypes.caseRefusalReason);
    dispatch({ type: DictionaryActionTypes.SET_CASE_REFUSAL_REASON, payload: data });
  };
  const getNationality = async () => {
    dispatch({ type: DictionaryActionTypes.SET_NATIONALITY, payload: [] });
    const data = await getDictionary(EDictionaryTypes.nationality);
    dispatch({ type: DictionaryActionTypes.SET_NATIONALITY, payload: data });
  };
  const getLegalType = async () => {
    dispatch({ type: DictionaryActionTypes.SET_LEGAL_TYPE, payload: [] });
    const data = await getDictionary(EDictionaryTypes.legalType);
    dispatch({ type: DictionaryActionTypes.SET_LEGAL_TYPE, payload: data });
  };
  const getMeasurement = async () => {
    dispatch({ type: DictionaryActionTypes.SET_MEASUREMENT, payload: [] });
    const data = await getDictionary(EDictionaryTypes.measurementUnit);
    dispatch({ type: DictionaryActionTypes.SET_MEASUREMENT, payload: data });
  };
  const getCurrency = async () => {
    dispatch({ type: DictionaryActionTypes.SET_CURRENCY, payload: [] });
    const data = await getDictionary(EDictionaryTypes.currency);
    dispatch({ type: DictionaryActionTypes.SET_CURRENCY, payload: data });
  };

  const getMaritalStatus = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_MARITAL_STATUS,
      payload: [],
    });
    const maritalStatusData = await getDictionary(EDictionaryTypes.MaritalStatus);
    dispatch({
      type: DictionaryActionTypes.SET_MARITAL_STATUS,
      payload: maritalStatusData,
    });
  };

  const getIdentificationDocumentType = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_IDENTIFICATION_DOCUMENT_TYPE,
      payload: [],
    });
    const identificationDocumentTypeData = await getDictionary(
      EDictionaryTypes.IdentificationDocumentType,
    );
    dispatch({
      type: DictionaryActionTypes.SET_IDENTIFICATION_DOCUMENT_TYPE,
      payload: identificationDocumentTypeData,
    });
  };

  const getAttachmentDocumentTypeData = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_ATTACHMENT_DOCUMENT_TYPE,
      payload: [],
    });
    const attachmentDocumentTypeData = await getDictionary(
      EDictionaryTypes.attachmentDocumentTypeData,
    );
    dispatch({
      type: DictionaryActionTypes.SET_ATTACHMENT_DOCUMENT_TYPE,
      payload: attachmentDocumentTypeData,
    });
  };

  const getLegalStatus = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_STATUS,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.legalStatus);
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_STATUS,
      payload: data,
    });
  };
  const getLegalIndividualDeactivationReason = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_INDIVIDUAL_DEACTIVATION_REASON,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.legalIndividualDeactivationReason);
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_INDIVIDUAL_DEACTIVATION_REASON,
      payload: data,
    });
  };
  const getLegalOrganisationDeactivationReason = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_ORGANISATION_DEACTIVATION_REASON,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.legalOrganisationDeactivationReason);
    dispatch({
      type: DictionaryActionTypes.SET_LEGAL_ORGANISATION_DEACTIVATION_REASON,
      payload: data,
    });
  };
  const getApplicationProcessStatus = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_APPLICATION_PROCESS_STATUS,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.applicationProcessStatus);
    dispatch({
      type: DictionaryActionTypes.SET_APPLICATION_PROCESS_STATUS,
      payload: data,
    });
  };
  const getWeaponLicenceTemplateStatus = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCE_TEMPLATE_STATUS,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceTemplateStatus);
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCE_TEMPLATE_STATUS,
      payload: data,
    });
  };
  const getWeaponLicenceCaseStatus = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCE_CASE_STATUS,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.weaponLicenceCaseStatus);
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCE_CASE_STATUS,
      payload: data,
    });
  };
  const getWeaponLicencePrintStatus = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCE_PRINT_STATUS,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.weaponLicencePrintStatus);
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCE_PRINT_STATUS,
      payload: data,
    });
  };
  const getWeaponLicencePrintBatchStatus = async () => {
    const data = await getDictionary(EDictionaryTypes.weaponLicencePrintBatchStatus);
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCE_PRINT_BATCH_STATUS,
      payload: data,
    });
  };
  const getWeaponLicencePrintType = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCE_PRINT_TYPE,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.weaponLicencePrintType);
    dispatch({
      type: DictionaryActionTypes.SET_WEAPON_LICENCE_PRINT_TYPE,
      payload: data,
    });
  };
  const getTaskStatus = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_TASK_STATUS,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.taskStatus);
    dispatch({
      type: DictionaryActionTypes.SET_TASK_STATUS,
      payload: data,
    });
  };
  const getIntelligenceReportSourceSystem = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_INTELIGENCE_REPORT_SOURCE_SYSTEM,
      payload: [],
    });
    const data = await getDictionary(EDictionaryTypes.intelligenceReportSourceSystem);
    dispatch({
      type: DictionaryActionTypes.SET_INTELIGENCE_REPORT_SOURCE_SYSTEM,
      payload: data,
    });
  };

  const value = useMemo(
    () => ({
      ...state,
      getGender,
      getOrganisationStateType,
      getOrganisationCivilianType,
      getOrganisationMilitaryType,
      getOrganisationPoliceType,
      getOrganisationCategory,
      getLegalVisibility,
      getLegalEntityPrefix,
      getCivilianPrefix,
      getMilitaryPrefix,
      getPolicePrefix,
      getMake,
      getModel,
      getCaliber,
      getBarrelType,
      getState,
      getRegion,
      getCountry,
      getPhoneCode,
      getAddressType,
      getLegality,
      getManufacturer,
      getLevel,
      getFirearmAction,
      getFirearmType,
      getTransactionType,
      getLegalClassification,
      getManufacturerCountry,
      getTransactionInitialTypes,
      getTransactionMiddleTypes,
      getActivity,
      getCountryAll,
      getArtAncillaryOptions,
      getArtAccessoryCalibre,
      getArtAccessoryComposition,
      getArtAccessoryHostType,
      getArtAccessoryLightColour,
      getArtAccessoryMagnification,
      getArtAccessoryManufacturerFlashEliminator,
      getArtAccessoryManufacturerLaserLightModule,
      getArtAccessoryManufacturerMagazine,
      getArtAccessoryManufacturerOpticalSight,
      getArtAccessoryManufacturerSuppressor,
      getArtAccessoryReticle,
      getArtAccessoryType,
      getArtAccessoryUtility,
      getArtAccessoryProofHouse,
      getArtAmmunitionType,
      getArtAmmunitionManufacturer,
      getArtAmmunitionFactory,
      getArtAmmunitionCalibreGauge,
      getArtAmmunitionCartridgeComposition,
      getArtAmmunitionColourOfPrimerSealant,
      getArtAmmunitionProjectileShape,
      getArtAmmunitionFunctionalType,
      getArtAmmunitionShotSize,
      getArtAmmunitionMunitionType,
      getArtAmmunitionMunitionVelocity,
      getArtComponentType,
      getArtComponentManufacturer,
      getArtComponentCalibre,
      getArtComponentCapacity,
      getArtComponentProofHouse,
      getArtComposition,
      getAuditLogModule,
      getAuditLogEventType,
      getAuditLogEventName,
      getApiKeyType,
      getWeaponLicenceRegion,
      getWeaponLicenceCategory,
      getWeaponLicencePrimaryPurpose,
      getWeaponLicenceCondition,
      getWeaponLicenceCompetency,
      getWeaponLicenceLimit,
      getWeaponLicenceDuration,
      getWeaponLicenceFee,
      getWeaponLicencingAuthority,
      getWeaponLicenceGoodReason,
      getWeaponLicencePaymentStatus,
      getWeaponLicenceStatus,
      getWeaponLicenceHistoryAction,
      getApplicationProcessTypes,
      getNationality,
      getLegalType,
      getMeasurement,
      getCurrency,
      getMaritalStatus,
      getIdentificationDocumentType,
      getAttachmentDocumentTypeData,
      getLegalStatus,
      getLegalIndividualDeactivationReason,
      getLegalOrganisationDeactivationReason,
      getApplicationProcessStatus,
      getTask,
      getWeaponLicenceTemplateStatus,
      getCaseProcessTypes,
      getWeaponLicenceCaseStatus,
      getWeaponLicencePrintStatus,
      getWeaponLicencePrintBatchStatus,
      getWeaponLicencePrintType,
      getTaskStatus,
      getIntelligenceReportSourceSystem,
      getCaseRejectionReason,
      getCaseApprovalReason,
      getCaseRefusalReason,
      getOtherRequestTaskName,
    }),
    [state],
  );

  return <DictionaryContext.Provider value={value}>{children}</DictionaryContext.Provider>;
};
